import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=af95415a&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=af95415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af95415a",
  null
  
)

export default component.exports